export type TourMarkName =
  | 'check'
  | 'community'
  | 'flash'
  | 'full-run'
  | 'fits'
  | 'passport'
  | 'route'
  | 'search'
  | 'signal'
  | 'ticket'

interface TourMarkProps {
  className?: string
  name: TourMarkName
}

export function TourMark({ className, name }: TourMarkProps) {
  const common = {
    'aria-hidden': true,
    className: `tour-mark ${className ?? ''}`.trim(),
    focusable: false,
    viewBox: '0 0 48 48',
  } as const

  if (name === 'flash') {
    return (
      <svg {...common}>
        <path d="M28 3 9 27h12l-2 18 20-27H27Z" fill="currentColor" />
        <circle cx="12" cy="10" fill="none" r="3" stroke="currentColor" strokeWidth="2.5" />
      </svg>
    )
  }

  if (name === 'route') {
    return (
      <svg {...common}>
        <path d="M13 42c12-9-3-16 8-27 4-4 8-7 14-10" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="6" />
        <path d="M16 38 20 34M18 27l5-4M27 13l5-4" stroke="var(--ink, #090909)" strokeLinecap="round" strokeWidth="2" />
        <circle cx="12" cy="41" fill="currentColor" r="5" />
        <path d="m33 3 8 2-3 8-3-3-5 5-4-4 5-5Z" fill="currentColor" />
      </svg>
    )
  }

  if (name === 'signal') {
    return (
      <svg {...common}>
        <path d="M8 20h9l13-10v28L17 28H8Z" fill="currentColor" />
        <path d="M35 17c3 4 3 10 0 14M40 12c6 7 6 17 0 24" fill="none" stroke="currentColor" strokeLinecap="square" strokeWidth="3" />
      </svg>
    )
  }

  if (name === 'community') {
    return (
      <svg {...common}>
        <path d="M6 8h36v25H20L9 42l2-9H6Z" fill="none" stroke="currentColor" strokeLinejoin="miter" strokeWidth="3.5" />
        <path d="m23 12-6 11h7l-3 8 11-14h-7l3-5Z" fill="currentColor" />
      </svg>
    )
  }

  if (name === 'fits') {
    return (
      <svg {...common}>
        <path d="M19 10c0-4 2-7 5-7s5 2 5 5c0 3-2 5-5 6l-16 9 16 9 16-9-8-4" fill="none" stroke="currentColor" strokeLinecap="square" strokeLinejoin="miter" strokeWidth="3.5" />
        <path d="M8 23v12h32V23" fill="none" stroke="currentColor" strokeWidth="3.5" />
      </svg>
    )
  }

  if (name === 'search') {
    return (
      <svg {...common}>
        <circle cx="21" cy="21" fill="none" r="12" stroke="currentColor" strokeWidth="4" />
        <path d="m30 30 11 11" stroke="currentColor" strokeLinecap="square" strokeWidth="5" />
        <path d="m20 12-5 10h6l-2 8 9-13h-6l2-5Z" fill="currentColor" />
      </svg>
    )
  }

  if (name === 'full-run') {
    return (
      <svg {...common}>
        <path d="m24 2 5 10 11-4-4 11 10 5-10 5 4 11-11-4-5 10-5-10-11 4 4-11-10-5 10-5L8 8l11 4Z" fill="currentColor" />
        <circle cx="24" cy="24" fill="var(--ink, #090909)" r="6" />
      </svg>
    )
  }

  if (name === 'ticket') {
    return (
      <svg {...common}>
        <path d="M5 12h38v9c-5 0-5 6 0 6v9H5v-9c5 0 5-6 0-6Z" fill="none" stroke="currentColor" strokeWidth="3.5" />
        <path d="m18 30 5-13 2 7 7-3-8 10Z" fill="currentColor" />
      </svg>
    )
  }

  if (name === 'passport') {
    return (
      <svg {...common}>
        <circle cx="24" cy="24" fill="none" r="17" stroke="currentColor" strokeWidth="3.5" />
        <path d="m24 10 4 9 10 1-8 7 2 10-8-5-8 5 2-10-8-7 10-1Z" fill="currentColor" />
      </svg>
    )
  }

  return (
    <svg {...common}>
      <path d="m8 25 10 10L41 9" fill="none" stroke="currentColor" strokeLinecap="square" strokeLinejoin="miter" strokeWidth="6" />
      <path d="M7 10h8M37 35h5" stroke="currentColor" strokeWidth="3" />
    </svg>
  )
}
